import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openModal: false,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModalAdd: (state, action) => {
      state.openModal = action.payload;
    },
  },
});

export const { openModalAdd } = modalSlice.actions;

export default modalSlice.reducer;
